import { Badge, Button, Dropdown } from "antd";
import moment from "moment";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NotificationIcon from "../../../assets/icons/NotificationIcon";
import PLACEHOLDER_IMG from "../../../assets/images/placeholder.png";
import colors from "../../../constants/colors";
import { NOTIFICATION_API } from "../../../constants/constants";
import {
  useGetNotificationsQuery,
  useNotificationStatusMutation,
} from "../../../features/notification/notificationApi";
import useError from "../../../hooks/useError";
import CustomEmpty from "../../ui/CustomEmpty";
import Loader from "../../ui/Loader";

export default function NotificationMenu() {
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(false);
  const isLocalHost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1");
  const shouldSkipNotification =
    isLocalHost &&
    /api-digigo\.dev-sheba\.xyz/i.test(NOTIFICATION_API || "");
  // const [seenId, setSeenId] = useState<number | undefined>(undefined);
  const { isLoading, isError, error, data } = useGetNotificationsQuery(
    { params: { skip: 0, limit: 10 } },
    { skip: shouldSkipNotification }
  );
  const [
    notificationStatus,
    { isError: isSeenError, error: seenError, isLoading: seenLoading },
  ] = useNotificationStatusMutation();
  useError(isError, error, "Get notification fail");
  useError(isSeenError, seenError, "Notification seen fail");

  return (
    <Dropdown
      trigger={["click"]}
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      open={openDropdown}
      onOpenChange={setOpenDropdown}
      getPopupContainer={(trigger) => trigger.parentElement!}
      dropdownRender={() => (
        <div className="w-72 bg-white shadow rounded-md">
          <div className="flex items-center justify-between gap-2 py-1.5 px-3 shadow-sm shadow-gray-100 sticky top-0">
            <span className="text-xs text-header font-medium">
              Notifications
            </span>
            {data?.data?.notifications?.length ? (
              <Link
                className="text-xs text-body font-medium hover:text-header"
                to="/admin/notification"
                onClick={() => setOpenDropdown(false)}
              >
                View All
              </Link>
            ) : null}
          </div>

          <div>
            <div className="h-56 overflow-y-auto notification">
              {isLoading ? (
                <Loader />
              ) : data?.data?.notifications?.length ? (
                data?.data?.notifications?.map((el) => {
                  return (
                    <div
                      className={`mb-1.5 cursor-pointer ${
                        el?.status === "unseen" ? "bg-light/30" : ""
                      }`}
                      key={el?.id}
                      onClick={() => {
                        if (!seenLoading) {
                          // setSeenId(el?.id);
                          if (el?.status === "unseen") {
                            notificationStatus({
                              ids: [el?.id],
                            });
                          }

                          if (el?.type?.includes("support") && el?.target_id) {
                            navigate(
                              `/admin/support-tickets?targeId=${el?.target_id}`
                            );
                          } else if (
                            el?.type?.includes("leave") &&
                            el?.target_id
                          ) {
                            navigate(
                              `/admin/leave/leave-requests/view/${el?.target_id}`
                            );
                          }

                          setTimeout(() => setOpenDropdown(false), 0);
                        }
                      }}
                    >
                      <div className="grid grid-cols-50 gap-1.5 py-1.5 pl-1.5">
                        <div className="flex justify-center">
                          <img
                            className="w-10 h-10 object-cover rounded-full"
                            src={
                              el?.sender?.member?.profile?.pro_pic ||
                              PLACEHOLDER_IMG
                            }
                            alt=""
                          />
                        </div>
                        <div className="flex justify-between items-center">
                          <div className="relative -top-0.5">
                            <h6 className="text-body text-sm font-medium mb-1">
                              {el?.title}
                            </h6>

                            <div className="text-[#7d88f4] text-xs font-normal leading-normal break-all">
                              {moment
                                .utc(el?.created_at)
                                .local()
                                .format("DD MMM")}{" "}
                              {moment
                                .utc(el?.created_at)
                                .local()
                                .format("hh:mm a")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <CustomEmpty
                  rootClassName="pt-10"
                  imageStyle={{ height: 100 }}
                  // styles={{ image: { height: 100 } }}
                />
              )}
            </div>
          </div>
        </div>
      )}
    >
      <Badge
        count={data?.data?.unseen_count}
        color={colors.danger.color}
        style={{
          width: "24px",
          height: "24px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: 500,
          left: 4,
          top: 4,
        }}
        className="!leading-none"
        // showZero
      >
        <Button
          className="border-none shadow-sm"
          icon={<NotificationIcon />}
          size="small"
        />
      </Badge>
    </Dropdown>
  );
}
